import { access } from '@driftt/traffic-control'

export const userHasOrgIntegrationAccess = () => {
  return (access.isAdmin() || access.hasFeatures([{
    featureName: 'org_integrations',
    accessLevel: 'WRITE'
  }]))
}